/**
 * @generated SignedSource<<1cefbb8c8992a1116043744d797685f3>>
 * @relayHash c12c13cda033d90ffe1a2594e1fea10b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fc087fbd81be4ad450b1850cf643e940ddf428978fad8f4930851d1eda8df7dd

import type { ConcreteRequest } from 'relay-runtime';
export type JiraResourceIntegration = "ATTACHMENT" | "CONFLUENCE" | "GDRIVE" | "LOOM" | "WEBLINK" | "WHITEBOARD" | "%future added value";
export type JiraResourceParentName = "COMMENT" | "CUSTOMFIELD" | "DESCRIPTION" | "ENVIRONMENT" | "FORM" | "ISSUE" | "WORKLOG" | "%future added value";
export type JiraResourcesOrderField = "CREATED" | "FILENAME" | "FILESIZE" | "MIMETYPE" | "%future added value";
export type JiraResourcesSortDirection = "ASC" | "DESC" | "%future added value";
export type JiraIssueResourceFilters = {
  integration?: JiraResourceIntegration | null;
  types?: ReadonlyArray<string | null> | null;
};
export type consolidatedResourcesQuery$variables = {
  cloudId: string;
  currentPageNumber: number;
  filters?: ReadonlyArray<JiraIssueResourceFilters | null> | null;
  isLast: boolean;
  issueKey: string;
  maxResults?: number | null;
  next: string;
  orderDirection?: JiraResourcesSortDirection | null;
  orderField?: JiraResourcesOrderField | null;
  startAt?: string | null;
  targetPageNumber: number;
  totalCount: AGG$Long;
  totalLinks: AGG$Long;
};
export type consolidatedResourcesQuery$data = {
  readonly jira: {
    readonly issueByKey: {
      readonly deletableAttachmentsCount: number | null;
      readonly getConsolidatedResources: {
        readonly deletableCount: AGG$Long | null;
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly author: {
              readonly accountId: string;
            } | null;
            readonly contentId: string | null;
            readonly contentType: string | null;
            readonly contentUrl: string | null;
            readonly created: AGG$DateTime | null;
            readonly fileName: string | null;
            readonly fileSize: AGG$Long | null;
            readonly hasRestrictedParent: boolean | null;
            readonly id: string;
            readonly isExternallyLinked: boolean | null;
            readonly parent: JiraResourceParentName | null;
            readonly parentId: string | null;
          } | null;
        } | null> | null;
        readonly next: string | null;
        readonly totalCount: AGG$Long | null;
        readonly totalLinks: AGG$Long | null;
      } | null;
      readonly getConsolidatedResourcesTotalCount: AGG$Long | null;
      readonly totalAttachmentsCount: number | null;
    } | null;
  } | null;
};
export type consolidatedResourcesQuery = {
  response: consolidatedResourcesQuery$data;
  variables: consolidatedResourcesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "currentPageNumber"
},
v2 = {
  "defaultValue": [
    {
      "integration": "CONFLUENCE"
    },
    {
      "integration": "LOOM"
    },
    {
      "integration": "WHITEBOARD"
    },
    {
      "integration": "ATTACHMENT",
      "types": ([]/*: any*/)
    }
  ],
  "kind": "LocalArgument",
  "name": "filters"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isLast"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueKey"
},
v5 = {
  "defaultValue": 12,
  "kind": "LocalArgument",
  "name": "maxResults"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "next"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderDirection"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderField"
},
v9 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "startAt"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "targetPageNumber"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "totalCount"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "totalLinks"
},
v13 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "issueKey"
  }
],
v14 = {
  "args": [
    {
      "kind": "Literal",
      "name": "input",
      "value": {
        "integration": [
          "ATTACHMENT",
          "CONFLUENCE",
          "LOOM",
          "WHITEBOARD"
        ]
      }
    }
  ],
  "kind": "ScalarField",
  "name": "getConsolidatedResourcesTotalCount",
  "storageKey": "getConsolidatedResourcesTotalCount(input:{\"integration\":[\"ATTACHMENT\",\"CONFLUENCE\",\"LOOM\",\"WHITEBOARD\"]})"
},
v15 = {
  "kind": "ScalarField",
  "name": "deletableAttachmentsCount"
},
v16 = {
  "kind": "ScalarField",
  "name": "totalAttachmentsCount"
},
v17 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "after",
        "variableName": "startAt"
      },
      {
        "kind": "Variable",
        "name": "filters",
        "variableName": "filters"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "maxResults"
      },
      {
        "kind": "Variable",
        "name": "orderDirection",
        "variableName": "orderDirection"
      },
      {
        "kind": "Variable",
        "name": "orderField",
        "variableName": "orderField"
      },
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "currentPageNumber",
            "variableName": "currentPageNumber"
          },
          {
            "kind": "Variable",
            "name": "isLast",
            "variableName": "isLast"
          },
          {
            "kind": "Variable",
            "name": "pageCursor",
            "variableName": "next"
          },
          {
            "kind": "Variable",
            "name": "pageNumber",
            "variableName": "targetPageNumber"
          },
          {
            "kind": "Variable",
            "name": "pageSize",
            "variableName": "maxResults"
          },
          {
            "kind": "Literal",
            "name": "style",
            "value": "OFFSET"
          },
          {
            "kind": "Variable",
            "name": "totalCount",
            "variableName": "totalCount"
          },
          {
            "kind": "Variable",
            "name": "totalLinks",
            "variableName": "totalLinks"
          }
        ],
        "kind": "ObjectValue",
        "name": "pagination"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v18 = {
  "kind": "ScalarField",
  "name": "id"
},
v19 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v20 = {
  "kind": "ScalarField",
  "name": "created"
},
v21 = {
  "kind": "ScalarField",
  "name": "contentId"
},
v22 = {
  "kind": "ScalarField",
  "name": "contentUrl"
},
v23 = {
  "kind": "ScalarField",
  "name": "contentType"
},
v24 = {
  "kind": "ScalarField",
  "name": "fileName"
},
v25 = {
  "kind": "ScalarField",
  "name": "fileSize"
},
v26 = {
  "kind": "ScalarField",
  "name": "parent"
},
v27 = {
  "kind": "ScalarField",
  "name": "parentId"
},
v28 = {
  "kind": "ScalarField",
  "name": "hasRestrictedParent"
},
v29 = {
  "kind": "ScalarField",
  "name": "isExternallyLinked"
},
v30 = {
  "kind": "ScalarField",
  "name": "next"
},
v31 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v32 = {
  "kind": "ScalarField",
  "name": "deletableCount"
},
v33 = {
  "kind": "ScalarField",
  "name": "totalLinks"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/)
    ],
    "kind": "Fragment",
    "name": "consolidatedResourcesQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v13/*: any*/),
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issueByKey",
            "plural": false,
            "selections": [
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              {
                "args": (v17/*: any*/),
                "concreteType": "JiraResourcesResult",
                "kind": "LinkedField",
                "name": "getConsolidatedResources",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraResourceNode",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraResource",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v18/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                              (v19/*: any*/)
                            ]
                          },
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/),
                          (v26/*: any*/),
                          (v27/*: any*/),
                          (v28/*: any*/),
                          (v29/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v30/*: any*/),
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v33/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v0/*: any*/),
      (v5/*: any*/),
      (v9/*: any*/),
      (v8/*: any*/),
      (v7/*: any*/),
      (v2/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/),
      (v10/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "consolidatedResourcesQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v13/*: any*/),
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issueByKey",
            "plural": false,
            "selections": [
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              {
                "args": (v17/*: any*/),
                "concreteType": "JiraResourcesResult",
                "kind": "LinkedField",
                "name": "getConsolidatedResources",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraResourceNode",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraResource",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v18/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "__typename"
                              },
                              (v19/*: any*/),
                              (v18/*: any*/)
                            ]
                          },
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/),
                          (v26/*: any*/),
                          (v27/*: any*/),
                          (v28/*: any*/),
                          (v29/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v30/*: any*/),
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v33/*: any*/)
                ]
              },
              (v18/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "fc087fbd81be4ad450b1850cf643e940ddf428978fad8f4930851d1eda8df7dd",
    "metadata": {},
    "name": "consolidatedResourcesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "4dc26801875053a667498cedf71d28b2";

export default node;
